import { useCallback, useEffect, useMemo, useState } from "react";
import { ProductData, SortFSType } from "../types";

function useStrumentiSort(data: ProductData[]) {
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "asc",
  });

  const sortFSArray: SortFSType[] = [
    "ascFS",
    "descFS",
    "ascFSAdvice",
    "descFSAdvice",
  ];
  const [sortConfigFS, setSortConfigFS] = useState<number>(-1);

  // Enhanced sorting function to handle different keys and sort types
  const sortedData = useMemo(() => {
    // If no sort config is set, return the original data
    if (!sortConfig.key) {
      return data;
    }

    let dynamicKey = sortConfig.key;
    let dynamicDirection = sortConfig.direction;
    if (sortConfig.key === "final_score_advice") {
      switch (sortFSArray[sortConfigFS]) {
        case "ascFS":
          dynamicKey = "final_score";
          dynamicDirection = "asc";
          break;
        case "descFS":
          dynamicKey = "final_score";
          dynamicDirection = "desc";
          break;
        case "ascFSAdvice":
          dynamicKey = "final_score_advice";
          dynamicDirection = "asc";
          break;
        case "descFSAdvice":
          dynamicKey = "final_score_advice";
          dynamicDirection = "desc";
          break;
      }
    }
    return [...data].sort((a, b) => {
      const key = dynamicKey;

      // Apply different sorting logic based on the key
      switch (key) {
        case "peso_sul_ptf":
        case "costi_totali_stimati":
        case "rating_ESG":
        case "final_score":
        case "final_score_advice":
          // Numeric sorting
          const numA = Number(a[key]) || 0;
          const numB = Number(b[key]) || 0;
          return dynamicDirection === "asc" ? numA - numB : numB - numA;

        // case "final_score_advice":
        //   // Numeric sorting
        //   const numA1 = Number(a[key]) || 0;
        //   const numB1 = Number(b[key]) || 0;
        //   return dynamicDirection === "asc" ? numA1 - numB1 : numB1 - numA1;

        case "microcategoria_advice":
          // Alphabetical sorting
          const strA = String(a[key] || "").toLowerCase();
          const strB = String(b[key] || "").toLowerCase();
          return dynamicDirection === "asc"
            ? strA.localeCompare(strB)
            : strB.localeCompare(strA);

        default:
          // Default string sorting
          const valA = String(a[key] || "").toLowerCase();
          const valB = String(b[key] || "").toLowerCase();
          return dynamicDirection === "asc"
            ? valA.localeCompare(valB)
            : valB.localeCompare(valA);
      }
    });
  }, [data, sortConfig, sortConfigFS]);

  // Enhanced sorting function to handle different keys and sort types

  const handleSort = useCallback(
    (key) => {
      if (key === "final_score_advice") {
        let sortConfigFSUpdate = sortConfigFS + 1;
        if (sortConfigFSUpdate > sortFSArray.length - 1) {
          sortConfigFSUpdate = 0;
        }
        setSortConfigFS(sortConfigFSUpdate);
        setSortConfig((prevConfig) => {
          const direction = prevConfig.direction;
          return { key, direction };
        });
      } else {
        setSortConfig((prevConfig) => {
          let direction = "asc";
          if (prevConfig.key === key && prevConfig.direction === "asc") {
            direction = "desc";
          }
          return { key, direction };
        });
      }
    },
    [sortConfigFS],
  );

  useEffect(() => {
    handleSort("microcategoria_advice");
  }, []);

  return {
    sortConfig,
    sortedData,
    handleSort,
  };
}

export default useStrumentiSort;
